import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { logEvent, isSupported } from 'firebase/analytics';
import { analytics } from '../firebase';
import Home from './pages/Home';
import SolarPlan from './pages/SolarPlan';
import EVPlan from './pages/EVPlan';
import FullHomePlan from './pages/FullHomePlan';
import Products from './pages/Products';
import Plans from './pages/Plans';
import Aboutus from './pages/Aboutus';

// Component to track page views with error handling
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        if (
          typeof analytics !== 'object' ||
          typeof logEvent !== 'function' ||
          !(await isSupported())
        ) {
          console.log('Analytics is blocked or not supported in this environment');
          return;
        }

        const pageName = getPageName(location.pathname);

        logEvent(analytics, 'page_view', {
          page_path: location.pathname,
          page_location: window.location.href,
          page_title: document.title || pageName,
        });

        logEvent(analytics, 'screen_view', {
          firebase_screen: pageName,
          firebase_screen_class: pageName.replace(/\s+/g, ''),
        });

        if (location.pathname.startsWith('/plans/')) {
          logEvent(analytics, 'view_item', {
            item_name: pageName,
            item_category: 'plan',
            item_variant: location.pathname.split('/').pop(),
          });
        } else if (location.pathname === '/products') {
          logEvent(analytics, 'view_item_list', {
            item_list_name: 'Products',
            item_list_id: 'products_page',
          });
        }
      } catch (error) {
        console.log('Analytics event could not be logged:', error);
      }
    };


    trackPageView();
  }, [location]);

  // Helper function to get page name from path
  const getPageName = (path: string) => {
    switch (path) {
      case '/':
        return 'Home';
      case '/plans':
        return 'Plans Overview';
      case '/plans/solar':
        return 'Solar Plan';
      case '/plans/ev':
        return 'EV Plan';
      case '/plans/full-home':
        return 'Full Home Plan';
      case '/products':
        return 'Products';
      default:
        return path.charAt(0) === '/' ? path.substring(1) : path;
    }
  };

  return null;
}

function App() {
  return (
    <Router>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/plans/solar" element={<SolarPlan />} />
        <Route path="/plans/ev" element={<EVPlan />} />
        <Route path="/plans/full-home" element={<FullHomePlan />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<Aboutus />} />
      </Routes>
    </Router>
  );
}

export default App;